var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNokia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 46,
    viewBox: "0 0 97 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_754_15456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.83897 29.7439H3.50586V17.4548H10.9999L19.5971 26.6294V17.4548H23.9302V29.7439H16.588L7.83897 20.4127V29.7439ZM44.6625 25.9441C44.6625 27.6523 44.3005 28.2409 43.7004 28.8061C42.781 29.6473 41.444 29.9 38.8665 29.9H31.4682C28.8907 29.9 27.552 29.647 26.6334 28.8061C26.0345 28.2414 25.6717 27.6523 25.6717 25.9441V21.2067C25.6717 19.4987 26.0345 18.9103 26.6334 18.3446C27.552 17.5027 28.8909 17.25 31.4682 17.25H38.8668C41.444 17.25 42.7813 17.503 43.7004 18.3446C44.3002 18.91 44.6625 19.4984 44.6625 21.2067V25.9441ZM38.6845 26.7859C39.6741 26.7859 40.0232 26.7377 40.2601 26.5577C40.4826 26.3893 40.5806 26.1728 40.5806 25.4508V21.6994C40.5806 20.9777 40.4826 20.7623 40.2601 20.5933C40.0232 20.4127 39.6741 20.365 38.6845 20.365H31.6496C30.66 20.365 30.3113 20.4127 30.0749 20.5933C29.8518 20.7623 29.7543 20.9779 29.7543 21.6994V25.4508C29.7543 26.1726 29.8515 26.3893 30.0749 26.5577C30.3113 26.7377 30.66 26.7859 31.6496 26.7859H38.6845ZM50.9596 17.4548V29.7439H46.4321V17.4548H50.9596ZM58.6089 17.4548H64.586L56.5192 23.2031L65.6176 29.7439H59.2215L50.9596 23.3347L58.6089 17.4548ZM66.4528 17.4548H70.9817V29.7439H66.4528V17.4548ZM88.2451 29.7439L86.9053 27.6031H78.1436L76.8199 29.7439H71.8178L79.8437 17.4545H85.4718L93.4974 29.7439H88.2451ZM79.7169 24.9339H85.347L82.5314 20.4847L79.7169 24.9339Z",
    fill: "#1C4598"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_754_15456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90.0714,
    height: 12.65,
    fill: "white",
    transform: "translate(3.46484 17.25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNokia);
export default __webpack_public_path__ + "static/media/Nokia.9e778365c9cebdf66849c46b81dfb64c.svg";
export { ForwardRef as ReactComponent };